export const MEETING_AUDIO_FILETYPE_ID = 27;
export const SETTLEMENT_INVESRMENT_FILETYPE_ID = 29;
export const SETTLEMENT_EXIT_FILETYPE_ID = 30;

export const permissonPaths = {
  createMeeting: '/project/keyNode/createMeeting',
  vote: '/project/keyNode/vote',
  ts: '/project/keyNode/ts',
  followOn: '/project/keyNode/followon',
  pass: '/project/keyNode/pass',
  monitor: '/project/keyNode/monitor',
  baseEdit: '/project/info/baseEdit',
  dls: '/project/info/memberEdit/dealLeader',
  dms: '/project/info/memberEdit/dealMember',
  ddLs: '/project/info/memberEdit/ddLeader',
  ddMs: '/project/info/memberEdit/ddMember',
  cooperations: '/project/info/memberEdit/cooperate',
  partners: '/project/info/memberEdit/partner',
  laws: '/project/info/memberEdit/legal',
  finances: '/project/info/memberEdit/finance',
  backs: '/project/info/memberEdit/back',
  its: '/project/info/memberEdit/it',
  bps: '/project/info/memberEdit/bp',
  aims: '/project/info/memberEdit/aim',
  operatorVentureIds: '/project/info/memberEdit/operatorVentureIds',
  memberEdit: '/project/info/memberEdit',
  secretEdit: '/project/info/secretEdit',
  secretTypeEdit: '/project/info/secretEdit/secret',
  protectEdit: '/project/info/secretEdit/protect',
  projectDelete: '/project/info/delete',
  createLegal: '/project/info/createLegal',
  codeClass: '/project/info/codeClass',
  createOfflineMeeting: '/project/keyNode/createOfflineMeeting'
};

// export const GROWING_ICM_ID = 33;
// export const GROWING_ICA_ID = 34;
// export const GROWING_IL_ID = 35;
// export const GROWING_IM_ID = 36;
// export const EARLY_ICM_ID = 37;
// export const EARLY_ICA_ID = 38;
// export const EARLY_IL_ID = 39;
// export const EARLY_IM_ID = 40;

export const legalMap = {
  'tianchi.sourcecodecap.com': 'https://legal.sourcecodecap.com',
  'hubble.sourcecodecap.com': 'http://39.96.11.230',
  'hubble.sourcecodecap.com:8040': 'http://39.96.11.230',
  'hubble.sourcecodecap.com:8041': 'http://39.96.11.230:8101',
  'hubble.sourcecodecap.com:8042': 'http://39.96.11.230:8102',
  'hubble.sourcecodecap.com:8043': 'http://39.96.11.230:8103',
  'hubble.sourcecodecap.com:8045': 'http://39.96.11.230:8105',
  'hubble.sourcecodecap.com:8049': 'http://172.17.71.204:8108',

  'hubble.fe.dev.com:8046': 'http://39.96.11.230',
  'pretianchi.sourcecodecap.com': 'http://47.94.253.128'
};

export const pathWithoutPermission = [
  '/404',
  '/403',
  '/500',
  '/login',
  '/pdfview',
  '/project/meetingAudio',
  '/authorize',
  '/notify',
  '/project/voteRecords',
  '/project/votePage',
  '/finance/fundManage/fundChart',
  '/finance/middlePage/detail',
  '/finance/middlePage/dataDictionary',
  '/person',
  '/finance/fairvalueTable',
  '/finance/middlePage/detail/exit',
  '/finance/middlePage/detail/deal',
  '/finance/middlePage/detail/event',
  '/finance/middlePage/historySlice',
  '/project/round',
  '/data/report/investPerformance',
  '/data/report/USDIR',
  '/data/report/legalDeliveryScale',
  '/data/report/legalStartScale',
  '/data/report/voteOverviewReport',
  '/data/report/voteRawReport',
  '/kp/seed/detail',
  '/meeting/list',
  '/data/report/middlePage',
  '/data/report/qualityReport',
  '/data/report/irRmb',
  '/data/report/irUsd',
  '/data/report/controllist'
];

export const pathHasDrawer = ['/project/detail', '/pdfview'];

export const reportMap = {
  1: 'investPerformance',
  2: 'USDIR',
  3: 'legalDeliveryScale',
  4: 'legalStartScale',
  5: 'middlePage',
  6: 'voteRawReport',
  7: 'voteOverviewReport',
  8: 'qualityReport',
  10: 'irUsd',
  11: 'irRmb',
  12: 'controllist'
};

export const seedTableMap = {
  'tianchi.sourcecodecap.com': 'https://sourcecodecap.feishu.cn/base/bascnNMU9rTVJtkKaccrMjaXech',
  'hubble.sourcecodecap.com': 'https://x40vz7xy60.feishu.cn/base/bascnqI1tZfDR6rLXn6kAvkzvUd?table=tblTKThbcL9XU558&view=vew10HGhXA',
  'hubble.sourcecodecap.com:8040': 'https://x40vz7xy60.feishu.cn/base/bascnqI1tZfDR6rLXn6kAvkzvUd?table=tblTKThbcL9XU558&view=vew10HGhXA',
  'hubble.sourcecodecap.com:8041': 'https://x40vz7xy60.feishu.cn/base/bascnqI1tZfDR6rLXn6kAvkzvUd?table=tblTKThbcL9XU558&view=vew10HGhXA',
  'hubble.sourcecodecap.com:8042': 'https://x40vz7xy60.feishu.cn/base/bascnqI1tZfDR6rLXn6kAvkzvUd?table=tblTKThbcL9XU558&view=vew10HGhXA',
  'hubble.sourcecodecap.com:8043': 'https://x40vz7xy60.feishu.cn/base/bascnqI1tZfDR6rLXn6kAvkzvUd?table=tblTKThbcL9XU558&view=vew10HGhXA',
  'hubble.sourcecodecap.com:8045': 'https://x40vz7xy60.feishu.cn/base/bascnqI1tZfDR6rLXn6kAvkzvUd?table=tblTKThbcL9XU558&view=vew10HGhXA',
  'hubble.sourcecodecap.com:8049': 'https://x40vz7xy60.feishu.cn/base/bascnqI1tZfDR6rLXn6kAvkzvUd?table=tblTKThbcL9XU558&view=vew10HGhXA',
  'hubble.fe.dev.com:8046': 'https://x40vz7xy60.feishu.cn/base/bascnqI1tZfDR6rLXn6kAvkzvUd?table=tblTKThbcL9XU558&view=vew10HGhXA',
  'pretianchi.sourcecodecap.com': 'https://x40vz7xy60.feishu.cn/base/bascn13Tq3GdXIyf6J8yHCQOjvb?table=tblxD7jUt1yCTZdu&view=vewSBMBb3I'
};

export const irRmbTableMap = {
  'tianchi.sourcecodecap.com': 'https://sourcecodecap.feishu.cn/base/NUWrbKVkjad6m9sYvy2cpYGJnnb',
  'hubble.sourcecodecap.com': 'https://x40vz7xy60.feishu.cn/base/bascnLVBaOMtlbOWtDZumEQNTIe',
  'hubble.sourcecodecap.com:8040': 'https://x40vz7xy60.feishu.cn/base/bascnLVBaOMtlbOWtDZumEQNTIe',
  'hubble.sourcecodecap.com:8041': 'https://x40vz7xy60.feishu.cn/base/bascnLVBaOMtlbOWtDZumEQNTIe',
  'hubble.sourcecodecap.com:8042': 'https://x40vz7xy60.feishu.cn/base/bascnLVBaOMtlbOWtDZumEQNTIe',
  'hubble.sourcecodecap.com:8043': 'https://x40vz7xy60.feishu.cn/base/bascnLVBaOMtlbOWtDZumEQNTIe',
  'hubble.sourcecodecap.com:8045': 'https://x40vz7xy60.feishu.cn/base/bascnLVBaOMtlbOWtDZumEQNTIe',
  'hubble.sourcecodecap.com:8049': 'https://x40vz7xy60.feishu.cn/base/JTr1bAagcayphcsUaTLcxJG7nHc',
  'hubble.fe.dev.com:8046': 'https://x40vz7xy60.feishu.cn/base/bascnLVBaOMtlbOWtDZumEQNTIe'
  // 'pretianchi.sourcecodecap.com': 'https://x40vz7xy60.feishu.cn/base/bascn13Tq3GdXIyf6J8yHCQOjvb?table=tblxD7jUt1yCTZdu&view=vewSBMBb3I'
};

export const irUsdTableMap = {
  'tianchi.sourcecodecap.com': 'https://sourcecodecap.feishu.cn/base/JS1bb9vZ1adTiasoYfjc7fXOnwc',
  'hubble.sourcecodecap.com': 'https://x40vz7xy60.feishu.cn/base/bascnJen9LxaqqYCUn9VEuFHvWf',
  'hubble.sourcecodecap.com:8040': 'https://x40vz7xy60.feishu.cn/base/bascnJen9LxaqqYCUn9VEuFHvWf',
  'hubble.sourcecodecap.com:8041': 'https://x40vz7xy60.feishu.cn/base/bascnJen9LxaqqYCUn9VEuFHvWf',
  'hubble.sourcecodecap.com:8042': 'https://x40vz7xy60.feishu.cn/base/bascnJen9LxaqqYCUn9VEuFHvWf',
  'hubble.sourcecodecap.com:8043': 'https://x40vz7xy60.feishu.cn/base/bascnJen9LxaqqYCUn9VEuFHvWf',
  'hubble.sourcecodecap.com:8045': 'https://x40vz7xy60.feishu.cn/base/bascnJen9LxaqqYCUn9VEuFHvWf',
  'hubble.sourcecodecap.com:8049': 'https://x40vz7xy60.feishu.cn/base/D5yQbiRJta5MEusqW4kcHSAhnnc',
  'hubble.fe.dev.com:8046': 'https://x40vz7xy60.feishu.cn/base/bascnJen9LxaqqYCUn9VEuFHvWf'
  // 'pretianchi.sourcecodecap.com': 'https://x40vz7xy60.feishu.cn/base/bascn13Tq3GdXIyf6J8yHCQOjvb?table=tblxD7jUt1yCTZdu&view=vewSBMBb3I'
};

export const controllistTableMap = {
  'tianchi.sourcecodecap.com': 'https://sourcecodecap.feishu.cn/base/HFqhbhNRdaiCaysCO2gcGq9ynke',
  'hubble.sourcecodecap.com': 'https://x40vz7xy60.feishu.cn/base/bascnas6C2m7fGHZBYvjlbnfYtf',
  'hubble.sourcecodecap.com:8040': 'https://x40vz7xy60.feishu.cn/base/bascnas6C2m7fGHZBYvjlbnfYtf',
  'hubble.sourcecodecap.com:8041': 'https://x40vz7xy60.feishu.cn/base/bascnas6C2m7fGHZBYvjlbnfYtf',
  'hubble.sourcecodecap.com:8042': 'https://x40vz7xy60.feishu.cn/base/bascnas6C2m7fGHZBYvjlbnfYtf',
  'hubble.sourcecodecap.com:8043': 'https://x40vz7xy60.feishu.cn/base/bascnas6C2m7fGHZBYvjlbnfYtf',
  'hubble.sourcecodecap.com:8045': 'https://x40vz7xy60.feishu.cn/base/bascnas6C2m7fGHZBYvjlbnfYtf',
  'hubble.sourcecodecap.com:8049': 'https://x40vz7xy60.feishu.cn/base/OgKTbAUkiaUhhcss0ldcb91znGe',
  'hubble.fe.dev.com:8046': 'https://x40vz7xy60.feishu.cn/base/bascnas6C2m7fGHZBYvjlbnfYtf'
  // 'pretianchi.sourcecodecap.com': 'https://x40vz7xy60.feishu.cn/base/bascn13Tq3GdXIyf6J8yHCQOjvb?table=tblxD7jUt1yCTZdu&view=vewSBMBb3I'
};
